import createReducer from '../createReducer'
import {
  CHANGE_USER_PHOTO,
  CHANGE_USER_PHOTO_SUCCESSFUL,
  CHANGE_USER_PHOTO_FAILURE
} from './constants'
import { LOGOUT } from '../auth/constants'

const initialState = {
  isPhotoChanging: false
}

const reducer = createReducer(initialState, {
  [CHANGE_USER_PHOTO]: (state, action) => ({
    ...state,
    isPhotoChanging: true
  }),
  [CHANGE_USER_PHOTO_SUCCESSFUL]: (state, action) => ({
    ...state,
    isPhotoChanging: false
  }),
  [CHANGE_USER_PHOTO_FAILURE]: (state, action) => ({
    ...state,
    isPhotoChanging: false
  }),
  [LOGOUT]: (state, action) => ({
    ...initialState
  })
})

export default reducer
